export default "__VITE_ASSET__a2$Afg$U__"